'use client';

import { useContactCustomerService } from '@/components/contact-customer-service/use-contact-customer-service';
import customerNormal from '@/features/user-center/images/icon/customer-colorfull.png';
import customerVip from '@/features/user-center/images/icon/customer-colorfull-vip.png';
import { useGetVipUrl } from '@/services/chat-vip-url';
import { isLoginAtom } from '@/store';
import IconFont from '@/components/ui/iconFont';
import Image from 'next/image';
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';

interface IntelligentCustomerServiceProps {
  /**
   * 客服类型（可选）
   * 1 - 充值相关
   * 2 - 提现相关
   */
  type?: 1 | 2;
  /**
   * 订单号（可选）
   */
  orderId?: string;
  /**
   * 点击时的额外回调（可选）
   */
  onClickProp?: () => void;
  /**
   * 埋点当前页面名称
   */
  trackCurrentPage?: string;
}

export default function IntelligentCustomerService({ onClickProp, type, orderId, trackCurrentPage }: IntelligentCustomerServiceProps) {
  // 将数字类型转换为字符串类型以匹配 API 要求
  const typeString = type ? type.toString() as '1' | '2' : undefined;
  const { handleContact, isPending } = useContactCustomerService({ type: typeString, orderId, source: trackCurrentPage });

  const isLogin = useAtomValue(isLoginAtom);
  const { data: vipCustomerData } = useGetVipUrl({
    enabled: isLogin,
  });
  const customerImg = useMemo(() => {
    return !!vipCustomerData?.enable ? customerVip : customerNormal;
  }, [vipCustomerData]);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (isPending) {
      return;
    }

    // 执行额外的回调（如埋点）
    onClickProp?.();

    // 执行客服逻辑
    handleContact();
  };


  return (
    <button
      className='tap-target-34 active:scale-90 w-[20px] h-[20px] leading-none'
      onClick={handleClick}
    >
      {
        isLogin && vipCustomerData?.enable ?
          <Image src={customerImg} alt='customer' height={20}></Image> :
          <IconFont name="customer-service" color='#a9b5cb' size={18}></IconFont>
      }
    </button>
  );
}
